import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
} from '@angular/core';

import { DbsSpinnerComponent } from './dbs-spinner.component';

@Injectable({
  providedIn: 'root',
})
export class DbsSpinnerService {
  spinner: ComponentRef<DbsSpinnerComponent>;
  spinnerExist = false;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
  ) {}

  show(options?: { fullWhite?: boolean }) {
    if (!this.spinnerExist) {
      this.spinner = this.componentFactoryResolver.resolveComponentFactory(DbsSpinnerComponent).create(this.injector);
      if (options?.fullWhite) {
        this.spinner.instance.fullWhite = options.fullWhite;
      }
      this.appRef.attachView(this.spinner.hostView);
      const domElem = (this.spinner.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      document.body.appendChild(domElem);
      this.spinnerExist = true;
    }
  }

  hide() {
    if (this.spinnerExist) {
      this.appRef.detachView(this.spinner.hostView);
      this.spinner.destroy();
      this.spinnerExist = false;
    }
  }
}
